export default __webpack_public_path__ + "static/media/INACTIVE-2.387214c1.png";